var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroBrowserFirefoxBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_151_1",
    "data-name": "Component 151 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.582,
    height: 138.894,
    viewBox: "0 0 148.582 138.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.894,
    cy: 0.131,
    fx: 0.9345933198928833,
    fy: 0.10964557528495789,
    r: 1.219,
    gradientTransform: "matrix(0.927, 0, 0, -1, -0.115, 49.707)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ff9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    stopColor: "#ff5d30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ff3450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#ff0d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#ff0b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fd007d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#f40082"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.083,
    cy: 0.236,
    fx: 0.10608362406492233,
    fy: 0.22401897609233856,
    r: 0.704,
    gradientTransform: "matrix(0.927, 0, 0, -1, -0.174, 49.497)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d30082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0d6f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.991,
    cy: 0.125,
    fx: 1.0354769229888916,
    fy: 0.10106001794338226,
    r: 1.336,
    gradientTransform: "matrix(0.927, 0, 0, -1, -0.108, 49.72)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#ffd800",
    stopOpacity: 0.525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#ffca00",
    stopOpacity: 0.435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288,
    stopColor: "#ffb200",
    stopOpacity: 0.341
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff9100",
    stopOpacity: 0.239
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#ff6612",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#ff302b",
    stopOpacity: 0.027
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#ff1f30",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.529,
    cy: 0.556,
    r: 1.795,
    gradientTransform: "matrix(0.927, 0, 0, -1, -0.142, 48.857)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.153,
    stopColor: "#af0611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#ed1e32",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ff2d47",
    stopOpacity: 0.192
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#ff3450",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.398,
    cy: 0.535,
    r: 1.807,
    gradientTransform: "matrix(0.927, 0, 0, -1, -0.151, 48.9)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#af0611"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#ed1e32",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#ff2d47",
    stopOpacity: 0.192
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#ff3450",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.898,
    cy: 0.115,
    fx: 0.9413855075836182,
    fy: 0.09189607948064804,
    r: 1.257,
    gradientTransform: "matrix(0.935, 0, 0, -1, -0.132, 54.073)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#ff7232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#ff5b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#ff4e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#ff3e55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#ff3450"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.898,
    cy: 0.161,
    fx: 0.9391326308250427,
    fy: 0.13927949965000153,
    r: 1.192,
    gradientTransform: "matrix(0.935, 0, 0, -1, -0.132, 53.976)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208,
    stopColor: "#ffd600",
    stopOpacity: 0.831
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#ffbf00",
    stopOpacity: 0.569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#ff9b00",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#ff7c00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.623,
    cy: 0.532,
    r: 0.6,
    gradientTransform: "matrix(0.231, 0.969, 0.946, -0.258, -26.833, 34.939)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#ff3450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#ff424a",
    stopOpacity: 0.788
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ff7232",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.522,
    cy: 0.581,
    r: 0.607,
    gradientTransform: "matrix(0.231, 0.969, 0.907, -0.247, -26.302, 34.926)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#ff3450",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ff424a",
    stopOpacity: 0.631
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#ff7232",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 1.262,
    cy: -0.037,
    r: 2.701,
    gradientTransform: "matrix(1.102, 0, 0, -1, 0.32, 69.085)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#fff339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ff9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#ff840d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#ff772b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#ff7232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.738,
    y1: 24.787,
    x2: 0.227,
    y2: 23.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff339",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff339",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.097,
    y1: 36.253,
    x2: -3.097,
    y2: 37.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008ee9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#1982ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#8565fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#a059ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#b24ffb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#dd37eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df36ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3.257,
    y1: 37.283,
    x2: -2.761,
    y2: 36.344,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#a059ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80008e",
    stopOpacity: 0.502
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(-3.401 -7.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M151.983,121.2V25.613c0-12.489-4.895-18.294-15.651-18.294H19.476C8.72,7.319,3.4,13.124,3.4,25.613V121.2H71.412V134.55H45.444v11.663h64.92V134.55H84.4V121.2Zm-139-95.59c0-4.163,2.907-7.538,6.492-7.538H136.331c3.585,0,6.492,3.375,6.492,7.538v82.913H12.984Z",
    transform: "translate(0 0)",
    fill: "#adaeb0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "firefox_1_",
    "data-name": "firefox (1)",
    transform: "translate(37.936 18.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(7.767 17.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M54.693,123.1Z",
    transform: "translate(-54.693 -123.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M54.693,123.1Z",
    transform: "translate(-54.693 -123.099)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M54.693,123.1Z",
    transform: "translate(-54.693 -123.099)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(7.767 17.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M54.693,123.1Z",
    transform: "translate(-54.693 -123.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M54.693,123.1Z",
    transform: "translate(-54.693 -123.099)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(0 5.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M65.377,46.042a35.587,35.587,0,0,0-10.076-9,.481.481,0,0,0-.563.07h0a.459.459,0,0,0,.07.7A30.471,30.471,0,0,1,68.736,59.847C71.374,80.07,57.252,96.952,37.381,97,15.54,97.075,2.245,77.766,5.727,60.427A19.958,19.958,0,0,1,6.1,57.895,34.041,34.041,0,0,1,9.912,45.18C7.4,46.482,4.2,50.6,2.614,54.395A37.384,37.384,0,0,0,.258,72.684c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.377,46.042Z",
    transform: "translate(0 -36.977)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M65.377,46.042a35.587,35.587,0,0,0-10.076-9,.481.481,0,0,0-.563.07h0a.459.459,0,0,0,.07.7A30.471,30.471,0,0,1,68.736,59.847C71.374,80.07,57.252,96.952,37.381,97,15.54,97.075,2.245,77.766,5.727,60.427A19.958,19.958,0,0,1,6.1,57.895,34.041,34.041,0,0,1,9.912,45.18C7.4,46.482,4.2,50.6,2.614,54.395A37.384,37.384,0,0,0,.258,72.684c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.377,46.042Z",
    transform: "translate(0 -36.977)",
    opacity: 0.67,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M65.377,46.042a35.587,35.587,0,0,0-10.076-9,.481.481,0,0,0-.563.07h0a.459.459,0,0,0,.07.7A30.471,30.471,0,0,1,68.736,59.847C71.374,80.07,57.252,96.952,37.381,97,15.54,97.075,2.245,77.766,5.727,60.427A19.958,19.958,0,0,1,6.1,57.895,34.041,34.041,0,0,1,9.912,45.18C7.4,46.482,4.2,50.6,2.614,54.395A37.384,37.384,0,0,0,.258,72.684c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.377,46.042Z",
    transform: "translate(0 -36.977)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0 5.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M65.377,46.042a35.587,35.587,0,0,0-10.076-9,.481.481,0,0,0-.563.07h0a.459.459,0,0,0,.07.7A30.471,30.471,0,0,1,68.736,59.847C71.374,80.07,57.252,96.952,37.381,97,15.54,97.075,2.245,77.766,5.727,60.427A19.958,19.958,0,0,1,6.1,57.895,34.041,34.041,0,0,1,9.912,45.18C7.4,46.482,4.2,50.6,2.614,54.395A37.384,37.384,0,0,0,.258,72.684c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.377,46.042Z",
    transform: "translate(0 -36.977)",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M65.377,46.042a35.587,35.587,0,0,0-10.076-9,.481.481,0,0,0-.563.07h0a.459.459,0,0,0,.07.7A30.471,30.471,0,0,1,68.736,59.847C71.374,80.07,57.252,96.952,37.381,97,15.54,97.075,2.245,77.766,5.727,60.427A19.958,19.958,0,0,1,6.1,57.895,34.041,34.041,0,0,1,9.912,45.18C7.4,46.482,4.2,50.6,2.614,54.395A37.384,37.384,0,0,0,.258,72.684c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.377,46.042Z",
    transform: "translate(0 -36.977)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(4.853 5.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M98.955,55.549A27.986,27.986,0,0,0,84.236,33.514a3,3,0,0,0-3.781.721l-.018.018a30.287,30.287,0,0,1,14.385,24.62C95.156,70.848,85.326,80.4,74,80.942c-8.23.4-15.985-3.57-19.784-11.536a19.468,19.468,0,0,1-1.776-5.75c-1.794-12.1,6.348-22.422,13.822-24.989C62.236,35.15,52.124,35.4,44.615,40.918A26.034,26.034,0,0,0,34.521,58.151a29.829,29.829,0,0,0,2.128,16.319A32.12,32.12,0,0,0,47.025,87.642,32.468,32.468,0,0,0,64.012,93.9c.9.07,1.811.106,2.708.106C90.76,94.043,101.206,75.825,98.955,55.549Z",
    transform: "translate(-34.175 -33.136)",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M98.955,55.549A27.986,27.986,0,0,0,84.236,33.514a3,3,0,0,0-3.781.721l-.018.018a30.287,30.287,0,0,1,14.385,24.62C95.156,70.848,85.326,80.4,74,80.942c-8.23.4-15.985-3.57-19.784-11.536a19.468,19.468,0,0,1-1.776-5.75c-1.794-12.1,6.348-22.422,13.822-24.989C62.236,35.15,52.124,35.4,44.615,40.918A26.034,26.034,0,0,0,34.521,58.151a29.829,29.829,0,0,0,2.128,16.319A32.12,32.12,0,0,0,47.025,87.642,32.468,32.468,0,0,0,64.012,93.9c.9.07,1.811.106,2.708.106C90.76,94.043,101.206,75.825,98.955,55.549Z",
    transform: "translate(-34.175 -33.136)",
    fill: "url(#radial-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(4.853 5.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M98.955,55.549A27.986,27.986,0,0,0,84.236,33.514a3,3,0,0,0-3.781.721l-.018.018a30.287,30.287,0,0,1,14.385,24.62C95.156,70.848,85.326,80.4,74,80.942c-8.23.4-15.985-3.57-19.784-11.536a19.468,19.468,0,0,1-1.776-5.75c-1.794-12.1,6.348-22.422,13.822-24.989C62.236,35.15,52.124,35.4,44.615,40.918A26.034,26.034,0,0,0,34.521,58.151a29.829,29.829,0,0,0,2.128,16.319A32.12,32.12,0,0,0,47.025,87.642,32.468,32.468,0,0,0,64.012,93.9c.9.07,1.811.106,2.708.106C90.76,94.043,101.206,75.825,98.955,55.549Z",
    transform: "translate(-34.175 -33.136)",
    opacity: 0.53,
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M98.955,55.549A27.986,27.986,0,0,0,84.236,33.514a3,3,0,0,0-3.781.721l-.018.018a30.287,30.287,0,0,1,14.385,24.62C95.156,70.848,85.326,80.4,74,80.942c-8.23.4-15.985-3.57-19.784-11.536a19.468,19.468,0,0,1-1.776-5.75c-1.794-12.1,6.348-22.422,13.822-24.989C62.236,35.15,52.124,35.4,44.615,40.918A26.034,26.034,0,0,0,34.521,58.151a29.829,29.829,0,0,0,2.128,16.319A32.12,32.12,0,0,0,47.025,87.642,32.468,32.468,0,0,0,64.012,93.9c.9.07,1.811.106,2.708.106C90.76,94.043,101.206,75.825,98.955,55.549Z",
    transform: "translate(-34.175 -33.136)",
    opacity: 0.53,
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(23.907 5.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M195.607,34.014c-.018.018-.018.035-.035.053a3.005,3.005,0,0,0,.44,4.2c5.452,4.467,9.109,10.815,9.109,18.148,0,10.129-7.843,17.849-17.023,17.3-13.646-.827-17.076-14.772-9.989-20.8-1.917-.4-5.5.387-8.019,4.133-2.251,3.359-2.128,8.529-.739,12.2a20.139,20.139,0,0,0,19.784,11.536c15.546-.95,22.193-13.769,22.615-22.9.457-9.9-1.776-18.676-12.363-24.584A2.971,2.971,0,0,0,195.607,34.014Z",
    transform: "translate(-168.346 -32.92)",
    fill: "url(#radial-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(0.018 8.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M65.483,62.3a34.39,34.39,0,0,0-3.165-3.6,29.478,29.478,0,0,0-2.884-2.655c.58.51,1.143,1.055,1.688,1.618a20.231,20.231,0,0,1,4.431,7.386c1.9,5.733,1.776,12.925-1.846,18.553A21.447,21.447,0,0,1,44.75,93.48c-.334,0-.651,0-.985-.018-13.646-.827-17.076-14.772-9.989-20.8-1.917-.4-5.5.387-8.019,4.133C23.507,80.15,23.63,85.32,25.019,89a19.468,19.468,0,0,1-1.776-5.751c-1.794-12.1,6.348-22.421,13.822-24.989-4.027-3.517-14.139-3.271-21.648,2.251A25.263,25.263,0,0,0,6.255,73.749a35.115,35.115,0,0,1,3.781-12.292c-2.515,1.3-5.715,5.416-7.3,9.215A37.381,37.381,0,0,0,.382,88.96c.053.475.106.932.158,1.407A36.4,36.4,0,1,0,65.483,62.3Z",
    transform: "translate(-0.124 -55.927)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(16.982 0.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M168.047,17.545a20.476,20.476,0,0,0-4.432-7.386c-4.22-4.537-10.428-7.439-16.407-8.758a36.21,36.21,0,0,0-15.053-.088c-5.17,1.09-9.707,3.324-12.574,6.1,9.918-5.8,23.283-4.73,32.428,1.776a28.367,28.367,0,0,1,4.238,3.71c6.085,6.559,8.564,17.515,3.447,25.393-2.567,3.992-8.089,7.72-13.242,7.685a21.489,21.489,0,0,0,19.731-9.865C169.823,30.471,169.946,23.278,168.047,17.545Z",
    transform: "translate(-119.581 -0.566)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(16.982 0.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M168.047,17.545a20.476,20.476,0,0,0-4.432-7.386c-4.22-4.537-10.428-7.439-16.407-8.758a36.21,36.21,0,0,0-15.053-.088c-5.17,1.09-9.707,3.324-12.574,6.1,9.918-5.8,23.283-4.73,32.428,1.776a28.367,28.367,0,0,1,4.238,3.71c6.085,6.559,8.564,17.515,3.447,25.393-2.567,3.992-8.089,7.72-13.242,7.685a21.489,21.489,0,0,0,19.731-9.865C169.823,30.471,169.946,23.278,168.047,17.545Z",
    transform: "translate(-119.581 -0.566)",
    fill: "url(#linear-gradient-3)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroBrowserFirefoxBuilding);
export default __webpack_public_path__ + "static/media/Asset-KuroBrowserFirefoxBuilding.0a66446341610280ee917960b32fd6c7.svg";
export { ForwardRef as ReactComponent };